import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Button, message } from 'antd';
import WebForm from '../../../Template/layoutComponents/WebForm';
import ErrorPage from '../../../Template/pages/ErrorPage';

import { useTranslation } from 'react-i18next';
import { createTask } from '../../helpers/apiCalls';
import useTemplateState from '../../../Template/atoms/variables';

import { useMsal } from '@azure/msal-react';

import './style.css';

const WebFormPage = () => {
  const location = useLocation();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { formData, stage } = location.state || {};
  const { setPendingApiCalls } = useTemplateState();
  const { plantId, assetId, interconnectionId } = useParams();

  const { instance } = useMsal();

  const handleBack = () => {
    navigate(-1);
  };

  const handleSubmit = async (submittedData, language) => {
    setPendingApiCalls((current) => current.concat(['createTask']));

    try {
      await createTask(instance, {
        forms: submittedData,
        language: language,
        stage: stage,
        subjectId: assetId ?? interconnectionId,
      });
      navigate(
        `/maintenance/plants/${plantId}/${assetId ? 'assets' : 'interconnections'}/${assetId ?? interconnectionId}`,
      );
      message.success(t('Form submitted successfully'));
    } catch (error) {
      message.error(t('Error submitting form'));
      console.error('Error creating task:', error);
    } finally {
      setPendingApiCalls((current) => current.filter((item) => item !== 'createTask'));
    }
    return Promise.resolve();
  };

  if (!formData) {
    return <ErrorPage customMessage={t('web_form_no_data')} />;
  }

  return (
    <div id='web-form-page'>
      <WebForm data={formData} onSubmit={handleSubmit} onBack={handleBack} />
    </div>
  );
};

export default WebFormPage;
